import React from "react";

import { NewLabel } from "./new-label";

import styles from "./styles.modules.scss";

type ContentCardProps = {
    id: number | string;
    children: JSX.Element | JSX.Element[];
    lang?: string;
    like?: {
        counter: number;
        liked: boolean;
    } | null;
    newUntil?: number | null;
};

const ContentCardView = ({
    children,
    newUntil,
}: ContentCardProps & {
    localization: LocalizationConfig;
}) => {
    const isNew =
        newUntil === undefined || newUntil === null
            ? false
            : newUntil > Date.now();

    const getIcon = () => {
        if (isNew) {
            return (
                <div className={`new ${styles.new}`}>
                    <NewLabel />
                </div>
            );
        }

        return null;
    };

    return (
        <div className={`content-card ${styles.contentCard}`}>
            <div className={`card-box ${styles.cardBox}`}>{children}</div>

            <div className={`overlay ${styles.overlay}`}>
                <div className={`state-icons ${styles.stateIcons}`}>
                    {getIcon()}
                </div>
            </div>
        </div>
    );
};

export const ContentCard: (props: ContentCardProps) => JSX.Element =
    ContentCardView;
